import { Config } from "./configTypes";

const url = window.location.href;

// Constants for domains
const CN_DOMAIN = "partner.triveinvest-cn";
const VN_DOMAIN = "partner.triveinvest-vn";
const PAYMENT_TEST_DOMAIN = "partnertest.triveinvest";

// Helper function to determine environment-based URLs
const getApiUrl = (): string => {
  if (url.includes(CN_DOMAIN))
    return process.env.REACT_APP_INVEST_API_URL_CN || "";
  if (url.includes(VN_DOMAIN))
    return process.env.REACT_APP_INVEST_API_URL_VN || "";
  return process.env.REACT_APP_INVEST_API_URL || "";
};

const getDepositUrl = (): string => {
  if (url.includes(PAYMENT_TEST_DOMAIN))
    return process.env.REACT_APP_DEPOSIT_URL || "";
  if (url.includes(CN_DOMAIN))
    return process.env.REACT_APP_DEPOSIT_URL_CN || "";
  if (url.includes(VN_DOMAIN))
    return process.env.REACT_APP_DEPOSIT_URL_VN || "";
  return process.env.REACT_APP_DEPOSIT_URL || "";
};

// Base configuration object
const triveInvestConfig: Config = {
  siteTitle: "Trive Invest",
  whatsappUrl: "+601116348323",

  zendesk: {
    ZENDESK_KEY: process.env.REACT_APP_INVEST_ZENDESK_KEY || "",
    ZENDESK_SUPPORT_EMAIL:
      process.env.REACT_APP_INVEST_ZENDESK_SUPPORT_EMAIL || "",
  },

  company: {
    COMPANY_ID: Number(process.env.REACT_APP_INVEST_COMPANY_ID) || 0,
  },

  api: {
    API_URL: getApiUrl(),
    DEPOSIT_URL: getDepositUrl(),
    FAQ_URL: process.env.REACT_APP_INVEST_FAQ_REDIRECT_URL || "",
  },
};

export default triveInvestConfig;
